/**
 * 全体設定 共通mixin
 */
export default {
    data() {
        // 設定データ以外のパラメータを保持しない
        return {
            is_enable: false
        };
    },
    props: {
        // 設定データ
        batch_setting_data: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        // 設定種別
        kind: {
            type: String,
            required: true,
        }
    },
    computed: {
        isEnable: {
            get() {
                return !!this.is_enable;
            },
            set(value) {
                this.is_enable = value;
            }
        }
    },
    watch: {
        // 親からの設定データ変更検知(get api実行時)
        batch_setting_data: {
            handler: function (value) {
                for (const key in value) {
                    this.$data[key] = value[key];
                }
            },
            deep: true
        },
    },
    methods: {
        // data定義から設定データを取得
        getData: function() {
            let data = {};
            for (const key in this.$data) {
                data[key] = this.$data[key];
            }
            return data;
        }
    }
};
